module.exports = __webpack_public_path__ + "static/media/know11.380b36d6.jpg";